import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useState } from "react";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import VotePage from "@/pages/VotePage";
import ArchivePage from "@/pages/ArchivePage";

function App() {
  // Shared state so picks persist across tab switches
  const [predictions, setPredictions] = useState({});
  const [bonusPicks, setBonusPicks] = useState({});
  const [votePicks, setVotePicks] = useState({});

  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <HomePage predictions={predictions} setPredictions={setPredictions}
              bonusPicks={bonusPicks} setBonusPicks={setBonusPicks} />
          } />
          <Route path="/veikkaa" element={
            <HomePage predictions={predictions} setPredictions={setPredictions}
              bonusPicks={bonusPicks} setBonusPicks={setBonusPicks} />
          } />
          <Route path="/vote" element={
            <VotePage votePicks={votePicks} setVotePicks={setVotePicks} />
          } />
          <Route path="/tapahtumat" element={<ArchivePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
